export default __webpack_public_path__ + "static/media/261.2b976298.gif";